<script>
	import { P, Heading } from 'flowbite-svelte';
	import AbstractID from '../../AbstractID';
	import AbstractIdCard from '../../components/AbstractIDCard.svelte';
	import site from '../../site';
</script>

<Heading tag="h3">Account</Heading>
<div class="mt-4">
	<P>
		Your {site.name} account is linked to your Abstract ID. To change your account settings, navigate to Abstract ID.
	</P>
	<AbstractIdCard clickable={false} />
</div>
